import { IHttpAPI, HttpAppRequest, IHttpResponse } from '@/logic/core/http'

export class TopProfileApi extends HttpAppRequest implements IHttpAPI {
  async profilesGET(): Promise<IHttpResponse> {
    const url = this.createURL('video/profiles')
    return await this.get(url)
  }
}
